module.exports = __webpack_public_path__ + "img/22_sp.780a24a8.gif";